<template>
	<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" @click="$emit('click')">
		<g :stroke="color" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
			<path d="m1 1 9.783 9.737M10.783 1 1 10.737"/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'close-icon',
	props: {
		color: {
			type: String,
			default: '#F09C2B', // Color naranja por defecto para no afectar otros sitios
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/close-icon.vue